import envs from "@/envs";
import { getLanguageCode } from "@/i18n/getDateFnsLocale";

interface CrispUser {
  email?: string;
  nickname?: string;
  phone?: string;
  avatar?: string;
  id?: string;
}

class CrispService {
  private static instance: CrispService;
  private websiteId: string = envs.VITE_CRISP_ID;

  private constructor() {}

  static getInstance(): CrispService {
    if (!CrispService.instance) {
      CrispService.instance = new CrispService();
    }

    return CrispService.instance;
  }

  getEmbedUrl(locale: string, user?: CrispUser): string {
    const baseUrl = `https://go.crisp.chat/chat/embed/?website_id=${this.websiteId}`;
    const params = new URLSearchParams();

    // Set locale
    params.append("locale", getLanguageCode(locale));

    // Set user information if provided
    if (user) {
      if (user.nickname) {
        params.append("user_nickname", user.nickname);
      }
      if (user.email) {
        params.append("user_email", user.email);
      }
      if (user.avatar) {
        params.append("user_avatar", user.avatar);
      }
      if (user.id) {
        // Generate secure token for session continuity
        const secureToken = user.id;

        params.append("token_id", secureToken);

        // Add user session data
        params.append("session_segments", JSON.stringify([user.id]));
        params.append(
          "session_data",
          JSON.stringify({
            user_id: user.id,
            firstName: user.nickname?.split(" ")[0] || "",
            lastName: user.nickname?.split(" ").slice(1).join(" ") || "",
          }),
        );
      }
    }

    const queryString = params.toString();

    return queryString ? `${baseUrl}&${queryString}` : baseUrl;
  }
}

export default CrispService;
export type { CrispUser };
